// extracted by mini-css-extract-plugin
export default {"pageCardOuter":"imports_history_page-module___pageCardOuter___f0257630","pageCardInner":"imports_history_page-module___pageCardInner___b6726e1e"};